import { adminAllStoragePoolsQueryAtom } from "@/admin/buckets/storagePoolsQuery.ts";
import { adminAllIpPoolQueryAtom } from "@/admin/floating_ips/floatingIpsQuery.ts";
import { NoticeBlock } from "@/components/NoticeBlock.tsx";
import { Percent } from "@/components/l10n/Percent.tsx";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";

function NotificationsSectionContent() {
    const storagePools = useSuspenseQueryAtom(adminAllStoragePoolsQueryAtom);
    const ipPools = useSuspenseQueryAtom(adminAllIpPoolQueryAtom);
    const storagePoolsOver80PercentUsed = [...storagePools.values()].filter(({ percent_used }) => percent_used > 80);
    const ipPoolsOver80PercentUsed = ipPools.filter(({ percent_used }) => percent_used > 80);

    if (!storagePoolsOver80PercentUsed.length && !ipPoolsOver80PercentUsed.length) return null;

    return (
        <>
            {!!ipPoolsOver80PercentUsed.length && (
                <NoticeBlock className="col-span-2" icon="jp-warning-icon">
                    <div>
                        <b className="uppercase">IP pools nearing capacity</b>
                        <ul className="m-0 pl-5">
                            {ipPoolsOver80PercentUsed.map(({ location, percent_used }) => (
                                <li key={location}>
                                    IP pool in <b>{location}</b> is{" "}
                                    <Percent value={percent_used} maximumFractionDigits={1} /> used.
                                </li>
                            ))}
                        </ul>
                        Add or release IP addresses to maintain available capacity.
                    </div>
                </NoticeBlock>
            )}

            {!!storagePoolsOver80PercentUsed.length && (
                <NoticeBlock className="col-span-2" icon="jp-warning-icon">
                    <div>
                        <b className="uppercase">Storage pools nearing capacity</b>
                        <ul className="m-0 pl-5">
                            {storagePoolsOver80PercentUsed.map(({ uuid, display_name, location, percent_used }) => (
                                <li key={`${location}-${uuid}`}>
                                    Storage pool <b>{display_name}</b> in {location} is{" "}
                                    <Percent value={percent_used} maximumFractionDigits={1} /> used.
                                </li>
                            ))}
                        </ul>
                        Free up space or expand the pool to maintain available capacity.
                    </div>
                </NoticeBlock>
            )}
        </>
    );
}

export function NotificationsSection() {
    return <NotificationsSectionContent />;
}
